import * as React from 'react';

import i18n from 'helper/i18n';

export type BoardFallbackPropsType = {
	allPeriods?: boolean;
};

export const BoardFallback = ({ allPeriods = false }: BoardFallbackPropsType) => (
	<div className="m-board-fallback">
		<h3 className="m-board-fallback__title">
			{i18n(`react.impulsCoach.molecules.BoardFallback${allPeriods ? '.allPeriods' : ''}.title`)}
		</h3>
		<p className="m-board-fallback__text">
			{i18n(`react.impulsCoach.molecules.BoardFallback${allPeriods ? '.allPeriods' : ''}.text`)}
		</p>
	</div>
);

BoardFallback.displayName = 'BoardFallback';

export default BoardFallback;
